define(function(require) {
	//const Marionette = require('backbone.marionette');
	//const tpl = require('../templates/t_itv_more_info.hbs');
	//const instrument_model = require('civicsModels/instrument_model');
	//const code_definition_model = require('civicsModels/code_definition_model');
	const edit_sites_tpl_us = require('./t_lov_edit_sites.hbs');
	const edit_sites_tpl_nz = require('./t_lov_edit_sites_nz.hbs');
	const edit_sites_tpl_au = require('./t_lov_edit_sites_au.hbs');
	const edit_sites_tpl_ca = require('./t_lov_edit_sites_ca.hbs');
	const search_results = require('./v_itv_edit_sites_search_results');
	const address_model = require('civicsModels/address_model');
	const parcel_model = require('civicsModels/parcel_model');
	const address_collection = require('civicsCollections/address_collection');
	const IpsModel = require('civicsBase/ipsModel');
	const IpsCollection = require('civicsBase/ipsModelCollection');
	const code_definition_collection = require('civicsCollections/code_definition_collection');
	const ViewManager = require('civicsUtils/view_manager');
	const constants = require('civicsUtils/constants');
	const mapView = require('./v_lov_map_view');
	const results_view = require('./v_lov_results_view');
	const Utils = require('civicsUtils/general_utilities');

	const regionFilterData = {
		'en-US': {
			streetNumber: 'Equal',
			PreDirection: 'Equal',
			streetName: 'LikeBoth',
			suffix: 'Equal',
			SubDesignation: 'LikeBoth',			//'LikeBoth' adds the wildcard to BOTH the front and back
			City: 'Like',
			postalCode: 'Like'
		},
		'en-NZ': {
			Flat: 'Equal',
			HouseNumber: 'Equal',
			streetName: 'LikeBoth',
			suffix: 'Equal',
			SubDesignation: 'LikeBoth',
			City: 'Like',
			postalCode: 'Like'
		},
		'en-AU': {
			Flat: 'Equal',
			HouseNumber: 'Equal',
			streetName: 'LikeBoth',
			suffix: 'Equal',
			SubDesignation: 'LikeBoth',
			City: 'Like',
			postalCode: 'Like'
		},
		'en-CA': {
			streetNumber: 'Equal',
			PreDirection: 'Equal',
			streetName: 'LikeBoth',
			suffix: 'Equal',
			SubDesignation: 'LikeBoth',
			City: 'Like',
			postalCode: 'Like'
		}
	};
	
	return Marionette.LayoutView.extend({
		className: 'add-site-modal v_lov_edit_sites',
		//tagName:'div',
		// childViewContainer: '.results-list',
		// childView: search_results,
		template: function () {
			var cultureInfo = '';
			cultureInfo = ViewManager.globalConfig().toJSON().cultureInfo;
			switch (cultureInfo) {
				case 'en-US':
					return edit_sites_tpl_us;
				case 'en-NZ':
					return edit_sites_tpl_nz;
				case 'en-AU':
					return edit_sites_tpl_au;
				case 'en-CA':
					return edit_sites_tpl_ca;
				default:
					return edit_sites_tpl_us;  // Default to US
			}				//console.log('Error: No region info. Cannot load proper template');
		}(),
		ui:{
			mapDiv:'.site-map',
			formDiv:'.site-form', // OBS Toggles form, might have to include header in it
			formFooter:'.bbm-modal-bottombar', // OBS Toggles form, might have to include header in it
			mapToggle:'.map-toggle .toggle-input', // Maybe also move buttons to bottom-bar and include them
			searchButton: '.search-button',
			addSiteButton: '.add-site-button',
			resultsDiv:'.results-region',
			preDirection: '.direction-container',
			suffix: '.suffix-container',
			closeModalButton: '.bbm-btn-close',
			modalContainer: '.bbm-wrapper .bbm-modal',
		},
		regions: {
			resultsRegion:'@ui.resultsDiv',
			mapRegion:'@ui.mapDiv'
		},
		events: {
			'click @ui.searchButton':'searchClicked',
			'click @ui.addSiteButton':'addSiteClicked',
			'change @ui.mapToggle':'mapToggled',
			'click .cancel-button': 'cancelClicked',
			'click .clear-all-fields': 'clearClicked',
			'click .type-site': 'typeSiteClicked',
			'click @ui.closeModalButton':'cancelClicked'
		},
		childEvents: {
			'siteSelected': 'siteSelected',
			'siteSelected2': 'siteSelected',
		},
		views: {},
		initialize: function(options) {
			this.config = options;
			this.title = options.title;
			this.config.allowNonHansenSites = options.allowNonHansenSites ? true: false;
			this.globalConfig = ViewManager.globalConfig().toJSON();
			this.mapEnabled = this.globalConfig.gis.enabled;
			this.collection = new address_collection();

			this.promiseArray = [];
			this.model = new address_model();
			this.modalRegion = options.modalRegion;
			this.siteType = 'address';
			this.config.addressParcelAllowed = this.config.parcelAllowed && this.config.addressAllowed;
			if (!this.config.addressParcelAllowed)
				// if false, check if parcel is allowed,
				// if it is not then address will be the initial value
				if(this.config.parcelAllowed)
					this.siteType = 'parcel';

			//get address info, if passed
			if (this.config.addressKey) {
				this.model = new address_model();
				this.model.set('id', this.config.addressKey);
				this.promiseArray.push(this.model.fetch({
					error: function(model, response, options){
						ViewManager.errorToWindow(response, this);
					}
				}));
				this.siteType = 'address';
			} else if (this.config.parcelID) {
				this.model = new parcel_model();
				this.model.set('id', this.config.parcelID);
				this.promiseArray.push(this.model.fetch({
					error: function(model, response, options){
						ViewManager.errorToWindow(response, this);
					}
				}));
				this.siteType = 'parcel';
			}

			if( this.mapEnabled ){
				//get saved mapToggle value
				var savedMapToggle = App.localStorage.get('CIVICS', 'MAP_TOGGLE');
				this.savedMapToggle = savedMapToggle ? savedMapToggle == 'checked' : false;
			}
			//get suffixes
			this.suffix_model = new code_definition_collection();
			this.suffix_model.moniker = 'Hansen.Property.StreetSuffix';

			//Canadian Addresses use a different grid for suffixes
			cultureInfo = ViewManager.globalConfig().toJSON().cultureInfo;
			if(cultureInfo === 'en-CA'){
				this.suffix_model.moniker = 'Hansen.Property.StreetType';
			}

			this.promiseArray.push(this.suffix_model.fetch({
				error: function(model, response, options){
					ViewManager.errorToWindow(response, this);
				}
			}));
			//get preDirection
			this.direction_model = new code_definition_collection();
			this.direction_model.moniker = 'Hansen.Property.Direction';
			this.promiseArray.push(this.direction_model.fetch({
				error: function(model, response, options){
					ViewManager.errorToWindow(response, this);
				}
			}));

		},

		onShow:function(){
			ViewManager.loading(true);
			//when fetches are completed, utilize the data
			$.when.apply($, this.promiseArray).done(_.bind(function() {
				this.suffixes = this.suffix_model.toJSON();
				this.preDirection = this.direction_model.toJSON();
				this.render();
				if( this.mapEnabled )
					this.mapToggled();
				ViewManager.loading(false)
			}, this));
		},
		onDestroy:function(){
			if(this.views.mapView){
				this.views.mapView.destroy()
			}
		// removes search message in maps when the modal is destroyed.
		$('.ol-control.top-4.left-3.growl').remove();

		},
		onRender: function() {
			if( this.mapEnabled ){
				this.ui.mapToggle.prop('checked',this.savedMapToggle);
			}

			// var preDirection = constants.PRE_DIRECTION();
			// this.loadSelectOptions('#suffix', this.suffixes, this.model.get('suffix'));
			// this.loadSelectOptions('#pre-direction', this.preDirection, this.model.get('PreDirection'));

			if (this.siteType == 'address') {
				$('.parcel-selected').hide();
				$('.address-selected').show();
			} else if (this.siteType == 'parcel') {
				$('.parcel-selected').show();
				$('.address-selected').hide();
			}

			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

		},
		mapToggled:function(e){
			ViewManager.resetErrorMessages(this);
			if (typeof $('.rhy.container-controlled-padded') === 'object')
					$('.rhy.container-controlled-padded').remove(); //need to remove this, it affects the top padding for the map view modal.

			App.localStorage.set('CIVICS', 'MAP_TOGGLE',this.ui.mapToggle.prop('checked') ? 'checked' : 'unchecked');
			if(this.ui.mapToggle.is(':checked')){
				this.views.mapView = new mapView({
					parent:this,
					config:this.config
				});

				this.mapRegion.show(this.views.mapView)
				this.ui.resultsDiv.hide();
				this.ui.mapDiv.show();
				this.ui.formDiv.hide();
				this.ui.formFooter.hide();
				this.ui.modalContainer.css('width','75%');
				//var parentnow = this.$el.parents('.bbm-modal.bbm-modal').css('width','75%');


			} else {
				this.ui.mapDiv.hide();
				this.ui.resultsDiv.show();
				this.ui.formDiv.show();
				this.ui.formFooter.show();
				this.ui.modalContainer.css('width','');
				//this.ui.modalContainer.css('width','560px');
			}

		},
		mapSiteSelected:function(json,model){
			this.triggerMethod('site:added', json,model);
			if(this.mapView){
				this.mapView.destroy();
			}
			if(this.modalRegion) {
				this.modalRegion.hideModal(this.focusNext());
			} else {
				this.destroy();
			}
		},
		searchClicked: function(e) {
			ViewManager.loading(true);
			if (e) {
				e.preventDefault()
				e.stopPropagation();
			}
			//cv 2018-08-28: look into why we are serializing this twice
			var data = Backbone.Syphon.serialize($('.add-site-modal'), {
				exclude: ['typeAddress', 'typeParcel']
			});
			data = _.extend(data,Utils.serializeDroppy($('.add-site-modal')));


			//this.collection = new address_collection();

			var filter = [];
			var page = [];
			let orderBy = [];
			if(this.siteType == 'address'){
				cultureInfo = ViewManager.globalConfig().toJSON().cultureInfo;
				var addressProperties = regionFilterData[cultureInfo];//all address properties needed to add to filter
				$.each(addressProperties, function(property, operator){
					if (data[property]) {//if data.property exists, add it to filter

						var value;
						if(operator === 'Like') {
							//Only add wildcard to end
							value = data[property].trim()+'%';
						}
						else if(operator === 'LikeBoth')	{
							//Add wildcard to front and back
							value = '%' + data[property].trim()+'%';
							//Set operator back to IPS Approved value
							operator = "Like";
						}
						else //'Equal'
							value = data[property].trim();

						filter.push({//add requirement to filter
							property: property,
							value: value,
							operator: operator
						});
					}
				});
				orderBy = [{
					property:'streetName',
					direction:'asc'
				},{
					property:'streetNumber',
					direction:'asc'
				}]

				if (data && data.hasOwnProperty("SubDesignation")) {
					orderBy.push({
						property:'SubDesignation',
						direction:'asc'
					});
				}

			}
			if (data.parcelID && this.siteType === "parcel") {
				filter.push({
					property: 'parcelID',
					value: data.parcelID.trim()+'%',
					operator: 'Like'
				});
			}
			if(this.siteType == 'address'){
				filter.push({
					property:'type',
					value:'Address'
				});
			}
			filter.push({
				property:'IsCurrent',
				value:'true'
			});

			var extendedFilter = {
				And: filter
			};

			var page = {
				max: 100
			};

			this.collection.reset();
			this.collection.urlAttributes = {
				extendedFilter: extendedFilter,
				page: page,
				orderBy: orderBy//emtpy or null order by just doesn't get applied, like in the case of parcel.
			};

			this.collection.siteType = this.siteType;
			this.collection.fetch({
				error: function(model, response, options){
					ViewManager.errorToWindow(response, this);
				}
			}).done(_.bind(function() {

				if(this.views.resultsView){
					this.views.resultsView.destroy();
					this.resultsRegion.empty();
				}
				this.views.resultsView = new results_view({
					config:this.config,
					collection:this.collection
				});
				this.resultsRegion.show(this.views.resultsView);
				this.ui.formFooter.hide();
				this.ui.searchButton.removeClass('btn-primary');
				this.ui.searchButton.addClass('btn-secondary');
				this.ui.resultsDiv.addClass('active');

				ViewManager.loading(false);
			}, this));
			this.selectedSiteID = null;
		},
		cancelClicked: function(e) {
			if(this.mapView){
				this.mapView.destroy();
			}
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		clearClicked: function(e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.render();
		},
		focusNext: function() {
			// find the applicant list and focus on the last added item's delete button (can't seem to make this work calling the container from the previous layout view)
			$(".primary-site-region .btn-icon, .additional-sites-list .btn-icon").last().focus();
		},
		addSiteClicked: function(e) {
			var self = this;
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			ViewManager.resetErrorMessages(this);

			if ((this.config.addressKey || this.config.parcelID) && this.selectedModel) {
				var editedKey = this.config.addressKey != null ? this.config.addressKey : this.config.parcelID;
				var editedType = this.config.addressKey != null ? 'address' : 'parcel';
				this.triggerMethod('site:updated', editedKey, editedType, this.selectedModel);
				if(self.mapView){
					self.mapView.destroy();
				}
				if(self.modalRegion) {
					self.modalRegion.hideModal(self.focusNext());
				} else {
					self.destroy();
				}
			} else if (this.selectedModel) {
				$.when(self.validateSiteEffective(this.selectedModelJSON))
				.then(() => self.mapSiteSelected(self.selectedModelJSON,self.selectedModel))
				.fail(err => ViewManager.errorToWindow(err,self));

				Utils.civicsToastPop( i18n.t('CIVICS.COMMON_EDIT_SITES.ADD_SITE_APPLIED'), "success");

				if(__DEV__)console.log('selected site: ',this.selectedModelJSON);
			} else {
				if(__DEV__)console.log('Error: no site selected');
			}

		},
		siteSelected: function(childView, selectedSiteID, description, model) {
			//this.selectedSiteID = selectedSiteID;
			//this.selectedSiteDescription = description;
			this.selectedModel = null;
			this.selectedModelJSON = null;
			if(model){
				this.selectedModel = model;
				this.selectedModelJSON = model.toJSON();
			}

			//this.selectedSiteType = this.siteType == 'address' ? 'Address':'Parcel'
		},
		typeSiteClicked: function(e) {
			var prevType = this.siteType;
			this.siteType = $(e.target).val();
			if (prevType != this.siteType) {
				this.collection.reset();
				var that = this;
				if (this.siteType == 'address') {
					$('.parcel-selected').fadeOut(500, function() {
						$('.address-selected').fadeIn();
					})
				} else if (this.siteType == 'parcel') {
				$('.address-selected').fadeOut(500, function() {
						$('.parcel-selected').fadeIn();
					})
				}

			}
			if(this.views.resultsView){
				this.views.resultsView.destroy();
				this.resultsRegion.empty();
			}

			this.ui.searchButton.addClass('btn-primary');
			this.ui.searchButton.removeClass('btn-secondary');
			this.ui.resultsDiv.removeClass('active');

		},
		validateSiteEffective: function(model){
			var self = this;
		 	var def = new $.Deferred();

			if(model.GISModel && model.GISModel == true) {
				switch(model.type.toLowerCase()){
					case 'address':
						 //no longer checking for null. null addrkeys will get resolved.
								if(model.ADDRKEY > 1) {
									this.addrModel = new address_model();
									this.addrModel.urlRoot = this.addrModel.urlRoot + '/' + model.ADDRKEY;
									this.addrModel.fetch({
										success: function(){
											if(self.addrModel.get('isEffective')) {
												 def.resolve();
											} else {
												 def.reject({validationError:{msg: i18n.t('CIVICS.COMMON_EDIT_SITES.ADDRESS_NOT_EFFECTIVE')}});
											}
										},
										error: function(model, response, options){
												def.reject(response);
										}
									});
								} else {
									def.resolve();
								}
					 break;
					case 'parcel':
						//no longer checking for null. null prclkeys will get resolved.
							if(model.PRCLKEY > 1) {
							  this.parcelModel = new parcel_model();
								this.parcelModel.urlRoot = this.parcelModel.urlRoot + '/' + model.PRCLKEY;
								this.parcelModel.fetch({
									success: function(){
										if(self.parcelModel.get('isEffective')) {
											def.resolve();
										} else {
											def.reject({validationError:{msg: i18n.t('CIVICS.COMMON_EDIT_SITES.PARCEL_NOT_EFFECTIVE')}});
										}
									},
									error: function(model, response, options){
											def.reject(response);
									}
								});
							} else {
								def.resolve();
							}
					 break;
					case 'coords':
						//check if coords is valid
						if(model.geometryType && model.geometryType.toLowerCase() == 'point'
						&& model.lat != undefined
						&& model.lon != undefined) {
							def.resolve();
						} else {
							def.reject({validationError:{msg: i18n.t('CIVICS.COMMON_EDIT_SITES.COORDS_NOT_IN_SYSTEM')}});
						}
					 break;
					default:
						//if we can't determine the type, reject
						def.reject({validationError:{msg: i18n.t('CIVICS.COMMON_EDIT_SITES.SITE_NOT_IN_SYSTEM')}});
					break;
				}
			} else {
				//if we are using the address/parcel search list. Not from map input.
				def.resolve();
			}
			return def.promise();

		},
		getPrimarySiteTypeLabel: function () {
			if(this.config.parcelAllowed)
				return i18n.t('CIVICS.COMMON_EDIT_SITES.PARCEL');
			return i18n.t('CIVICS.COMMON_EDIT_SITES.ADDRESS');
		},
		suffixes: [],
		preDirection: [],
		templateHelpers: function() {
			return {
				isAddress: this.siteType == 'address' || this.siteType == null,
				isParcel: this.siteType == 'parcel',
				parcelAllowed: this.config.parcelAllowed,
				addressParcelAllowed: this.config.addressParcelAllowed,
				primarySiteTypeLabel: this.getPrimarySiteTypeLabel(),
				title:this.title,
				mapEnabled: this.mapEnabled,
				preDirection: this.preDirection,
				suffixes: this.suffixes

			}
		}
	});
});
